import styled from 'styled-components'
import { devices } from '../../../../globalStyle'

export const Container = styled.div`
    position: absolute;
    background-color: #fff;
    width: 13vw;
    top: 12rem;
    right: 18%;
    padding-top: 0.3vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2;
    border: 1px solid #ebebeb;
    border-top-left-radius: 1vw;
    border-bottom-left-radius: 1vw;
    border-bottom-right-radius: 1vw;
    box-shadow: 0px 8px 16px 0px #0000001A;
    @media ${devices.largeDesktop} {
        width:11vw;   
    }

    .warning{
        border: 1px #ff0000 solid;
    }
`

export const FilterMainText = styled.h2`
    font-size: 1.1vw;
    margin-left: 0.9vw;
    margin-bottom: 0;
    @media ${devices.largeDesktop} {
        font-size:1vw;
    }
    `
    
    export const FilterSelectDiv = styled.div`
    position: relative;
    display: flex;
    background-color: #EBEBEB;
    width: 11vw;
    height: 5.2vh;
    margin-top: 2vh;
    margin-left: 1vw;
    border-radius: 2vw;
    @media ${devices.largeDesktop} {
        width:9vw;
    }
    `
    
    export const FilterSelectInput = styled.input`
    background-color: #EBEBEB;
    width: 8.5vw;
    height: 5.2vh;
    border: 0;
    padding: 0;
    padding-left: 1.2vw;
    border-radius: 2vw;
    font-size:0.9vw;
    @media ${devices.largeDesktop} {
        font-size: 0.7vw;
    }
    
    :focus {
        outline: 0;
        }
        `
        
        export const FilterSelectImg = styled.img`
        margin-left: 0.4vw;
        width: 1.2vw;
        cursor: pointer;
        @media ${devices.largeDesktop} {
            width:0.9vw;
            margin-left:-0.8vw;
        }
        `
        
        export const FilterTextInput = styled.input`
        width: 11vw;
        height: 5.2vh;
        background-color: #EBEBEB;
        border: 0;
        padding: 0;
        padding-left: 1.2vw;
        padding-right: 1.2vw;
        margin-top: 2vh;
        margin-left: 1vw;
        border-radius: 2vw;
        font-size: 0.9vw;
        @media ${devices.largeDesktop} {
            font-size:0.7vw;
            width:9vw;
        }
        
        :focus {
            outline: 0;
            }
            `
            
            export const WarningDiv = styled.div`
            `
            
            export const WarningText = styled.p`
            margin-top: 0.2vh;
            margin-right: 1vw;
            margin-left: 1vw;
            margin-bottom: 0;
            color: red;
            font-family: 'Inter', sans-serif;
            font-size: 0.6vw;
            `
            
            export const ApplyFilterButton = styled.button`
            width: 11vw;
            height: 5.2vh;
            background-color: #0090D3;
            border: 0;
            padding: 0;
            margin-top: 2vh;
            margin-left: 1vw;
            margin-bottom: 2vh;
            border-radius: 2vw;
            font-size: 1vw;
            color: #fff;
            cursor: pointer;
            @media ${devices.largeDesktop} {
                font-size:0.8vw;
                width:9vw;
            }
            `